import {EngineConfig_MemoryPalace} from "../../../Server/DB/engineConfigs/@EngineConfig/@EC_MemoryPalace.js";
import {NarrateText, NarrateText_ForEngineComp, NotifyNonTTSUtteranceEnd, NotifyNonTTSUtteranceStart} from "../../../Utils/Services/TTS.js";
import {LiveSession, TriggerPackage} from "../../LiveSession.js";
import {EngineSessionComp} from "./EngineSessionComp.js";
import {GetAudioFilesWithSubpath} from "../../../Store/main/general/CacheState.js";
import {PlaySound} from "../../../Utils/Bridge/Bridge_Native/MediaPlayer.js";
import {MemoryPalace_RecallResult} from "../SessionEvent.js";
import {GetStandardFilePathForTTSOptions} from "../../../Utils/Services/FilePaths.js";

export class NewPromptOptions {
	constructor(data?: Partial<NewPromptOptions>) {
		Object.assign(this, data);
	}
	direction_ifRelevant: "next"|"prev"|n;
	playPrompt = true;
	volumeMultiplier = 1;
	promptPlayAddsEvent = true;
}

export class MemoryPalaceComp extends EngineSessionComp<EngineConfig_MemoryPalace> {
	constructor(session: LiveSession, config: EngineConfig_MemoryPalace) {
		super(session, config, s=>config.enabled, s=>s.IsLocal());
	}

	GetTriggerPackages() {
		return [
			new TriggerPackage("MemoryPalaceComp", this.c.nextPrompt_triggerSet, this, {}, triggerInfo=>{
				this.NewPrompt();
			}),
			new TriggerPackage("MemoryPalaceComp", this.c.prevPrompt_triggerSet, this, {}, triggerInfo=>{
				this.NewPrompt({direction_ifRelevant: "prev"});
			}),
		];
	}

	currentPrompt: MPPromptInfo|n;
	async NewPrompt(options: Partial<NewPromptOptions> = {}) {
		const opt = new NewPromptOptions(options);
		const oldPrompt = this.currentPrompt;

		const isMove = this.s.coreData.launchType == "day" && Math.random() < this.c.prompt_chanceForMove && oldPrompt?.target != null && oldPrompt?.actionType != "move";
		let newPrompt: MPPromptInfo|n;
		if (isMove) {
			const movePhrase = this.c.prompt_movePhrase ?? `Move the $target`;
			newPrompt = {text: movePhrase.replaceAll("$target", oldPrompt.target), actionType: "move", target: oldPrompt!.target};
		} else {
			let newTarget: string|n;
			if (this.c.selectionType == "sequential") {
				const oldIndex = this.c.targetPool.indexOf(oldPrompt?.target ?? "");
				newTarget = this.c.targetPool[(oldIndex + (opt.direction_ifRelevant == "prev" ? -1 : 1)).WrapToRange(0, this.c.targetPool.length)];
			} else {
				const otherTargets = this.c.targetPool.filter(a=>a != oldPrompt?.target);
				newTarget = otherTargets.Random();
			}
			if (newTarget == null) return; // if no valid new-target, do nothing
			newPrompt = {text: newTarget, actionType: "find", target: newTarget};
		}
		this.currentPrompt = newPrompt;

		if (opt.playPrompt) {
			await this.PlayPrompt(opt.volumeMultiplier, opt.promptPlayAddsEvent);
		}

		return newPrompt;
	}
	async PlayPrompt(volumeMultiplier = 1, promptPlayAddsEvent = true) {
		if (this.currentPrompt == null) return; // if no valid target, do nothing
		const volumeMultiplier_final = this.c.voice_volumeMultiplier * volumeMultiplier;

		const filePathToBakedTTS = GetStandardFilePathForTTSOptions({text: this.currentPrompt.text, volumeMultiplier: 1, speedMultiplier: 1}); // during baking we use volume(1) and speed(1), so do the same here
		const audioFileEntry = GetAudioFilesWithSubpath(filePathToBakedTTS)[0];
		if (audioFileEntry) {
			/*NarrateText_ForEngineComp(this, this.currentPrompt.text, volumeMultiplier_final, undefined, {
				tryPlayFromFile: {
					filePathToBakedTTS: GetStandardFilePathForTTSOptions({text: this.currentPrompt.text, volumeMultiplier: 1, speedMultiplier: 1}), // during baking we use volume(1) and speed(1), so do the same here
					volume_preGlobalMultiplier: volumeMultiplier_final,
				}
			});*/
			const utteranceId = NotifyNonTTSUtteranceStart(this.currentPrompt.text);
			await PlaySound({entry: audioFileEntry}, {volume: volumeMultiplier_final});
			NotifyNonTTSUtteranceEnd(utteranceId);
		} else {
			NarrateText_ForEngineComp(this, this.currentPrompt.text, volumeMultiplier_final);
		}
		if (promptPlayAddsEvent) {
			const data = {type: this.currentPrompt.actionType, target: this.currentPrompt.target};
			this.s.AsLocal!.AddEvent({type: "MemoryPalace.PromptPlay", memoryPalace_promptPlay: data});
		}
	}

	NotifyRecallResult(data: MemoryPalace_RecallResult) {
		this.s.AsLocal!.AddEvent({type: "MemoryPalace.RecallResult", memoryPalace_recallResult: data});
	}
}

export type MPPromptActionType = "find"|"move";
export type MPPromptInfo = {text: string, actionType: MPPromptActionType, target: string};